










import { Component, Vue } from 'vue-property-decorator'

@Component({ name: 'NotFoundPage' })
export default class NotFoundPage extends Vue {
}
